function delay(value, time = 1000) {
  return new Promise(resolve => {
    setTimeout(resolve.bind(null, value), time);
  });
}

export default {
  getCampaign: () => delay({}),
}
